import { useTranslation } from 'react-i18next';

interface SrOnlyTextProps {
  i18nKey: string;
}

/** Texte traduit réservé aux lecteurs d'écran (libellé des boutons à icône seule). */
export const SrOnlyText = ({ i18nKey }: SrOnlyTextProps) => {
  const { t } = useTranslation();
  return <span className='sr-only'>{t(i18nKey)}</span>;
};
